  // Variables and elements
  const lightbox = document.getElementById('lightbox');
  const lightboxImg = document.getElementById('lightboxImg');
  const thumbnails = document.querySelectorAll('.thumbnail');
  const prevBtn = document.getElementById('prevBtn');
  const nextBtn = document.getElementById('nextBtn');

  let currentIndex = -1;
  const fullImages = [...thumbnails].map(img => img.dataset.full);

  // Function to show image in the lightbox
  function showImage(index) {
    if (index < 0) index = fullImages.length - 1;
    if (index >= fullImages.length) index = 0;
    currentIndex = index;

    // Add a smooth transition effect
    lightboxImg.style.transition = 'all 0.3s ease';
    // lightboxImg.style.opacity = 0; // Fade out before changing image

    setTimeout(() => {
      lightboxImg.src = fullImages[currentIndex];
      lightboxImg.style.opacity = 1; // Fade in after changing image
    }, 0); // Wait for fade-out to complete before changing image

    lightbox.style.display = 'flex';
  }

  // Event listeners for thumbnails
  thumbnails.forEach((img, i) => {
    img.addEventListener('click', () => showImage(i));
  });

  // Close lightbox when clicking outside image
  lightbox.addEventListener('click', (e) => {
    if (e.target === lightbox) {
      lightbox.style.display = 'none';
      lightboxImg.src = '';
    }
  });

  // Clicking the lightbox image itself to change to next photo
  lightboxImg.addEventListener('click', () => showImage(currentIndex + 1));

  // Keyboard support
  document.addEventListener('keydown', (e) => {
    if (lightbox.style.display === 'flex') {
      if (e.key === 'ArrowRight') showImage(currentIndex + 1);
      if (e.key === 'ArrowLeft') showImage(currentIndex - 1);
      if (e.key === 'Escape') {
        lightbox.style.display = 'none';
        lightboxImg.src = '';
      }
    }
  });
